import React from 'react';
import {Suggestions} from 'components';

export function Dreams(props) {
  return (
    <Suggestions.List {...props}>
      <p>Own my home</p>
      <p>Travel around the world</p>
      <p>Loving and passionate relationships with my spouse</p>
      <p>Live in a different country</p>
      <p>Lose ... lb.</p>
      <p>Start my own business</p>
      <p>Start a family</p>
      <p>Start a second career</p>
      <p>Get involved with a project in Africa</p>
      <p>Be the President</p>
      <p>Find my soul mate</p>
      <p>Complete my college education</p>
      <p>Earn a Million Dollars</p>
      <p>Get my Ph.D.</p>
      <p>Get married</p>
      <p>Have my first child</p>
      <p>Be a leader</p>
      <p>Become a public speaker</p>
      <p>Write a book</p>
      <p>Become a millionaire</p>
      <p>Become the CEO of my company</p>
      <p>Inspire people</p>
      <p>Be a pilot</p>
      <p>Be healthy and fit</p>
      <p>Play the Piano</p>
    </Suggestions.List>
  );
}
